module.exports = __webpack_public_path__ + "static/media/Levin Fabric Wedge_Grey.5f976045.png";